import { formatJMD } from '../../lib/finances';
import { buildMonthlySummary } from '../../lib/financeReports';

export default function MonthlySummary({ expenses, income, period, periodLabel }) {
  const summary = buildMonthlySummary(income, expenses, period);

  return (
    <table className="entry-table">
      <thead>
        <tr>
          <th>Month</th>
          <th>Income</th>
          <th>Expenses</th>
          <th>Net</th>
        </tr>
      </thead>
      <tbody>
        {summary.rows.map((row) => (
          <tr key={row.label}>
            <td>{row.label}</td>
            <td>{formatJMD(row.incomeTotal)}</td>
            <td>{formatJMD(row.expenseTotal)}</td>
            <td>{formatJMD(row.net)}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td className="entry-table-total-label">{periodLabel} total</td>
          <td className="entry-table-total-value">{formatJMD(summary.incomeTotal)}</td>
          <td className="entry-table-total-value">{formatJMD(summary.expenseTotal)}</td>
          <td className="entry-table-total-value">{formatJMD(summary.net)}</td>
        </tr>
      </tfoot>
    </table>
  );
}
